import { useNavigate } from "react-router-dom";
import GestionActivity from "../../components/GestionActivity"
import { useSelector } from "react-redux";
import { useEffect } from "react";

const AdminDashboard = ()=>{
    const { user: authUser } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    
    useEffect(()=>{
        if(!authUser)
        navigate("/");
    }, [authUser])
    return(
        <main className="background-secondary">
            <GestionActivity/>
        </main>
    )
    
}
export default AdminDashboard
